module.exports = __webpack_public_path__ + "static/qr-generator-f2ee070520f60392272c6e1284247372.png";